export const SHOW_PROCESING_PAYMENT_MODAL =
    'modals/SHOW_PROCESING_PAYMENT_MODAL';
export const SHOW_PROCESING_PAYMENT_MODAL_COMPLETED = `${SHOW_PROCESING_PAYMENT_MODAL} [completed]`;
export const SHOW_PROCESING_PAYMENT_MODAL_ERROR = `${SHOW_PROCESING_PAYMENT_MODAL} [error]`;
export const SHOW_PROCESING_PAYMENT_MODAL_AUTHENTICATION_REQUIRED = `${SHOW_PROCESING_PAYMENT_MODAL} [authentication required]`;

export const RESET_PROCESSING_PAYMENT_MODAL =
    'modals/RESET_PROCESSING_PAYMENT_MODAL';

export const PROCESSING_PAYMENT_MODAL_TRY_AGAIN =
    'modals/PROCESSING_PAYMENT_MODAL_TRY_AGAIN';
export const PROCESSING_PAYMENT_MODAL_RETURN_TO_DASHBOARD =
    'modals/PROCESSING_PAYMENT_MODAL_RETURN_TO_DASHBOARD';
